import { render, staticRenderFns } from "./ForumItem.vue?vue&type=template&id=76c0c92a&scoped=true"
import script from "./ForumItem.vue?vue&type=script&lang=js"
export * from "./ForumItem.vue?vue&type=script&lang=js"
import style0 from "./ForumItem.vue?vue&type=style&index=0&id=76c0c92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0c92a",
  null
  
)

export default component.exports